import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import _ from "lodash";
import Schemas from "schemas";

import { Control } from "components/ui-kit/control";
import { AuthStyles, Button, PhotoDropzone } from "components/ui-kit/styled-templates";

import districts from "constants/districts";
import countries from "constants/countries";

import UniversityApi from "api/university-api";

import useFormControl from "hooks/useFormControl";
import { useStorageListener } from "hooks/useStorage";

import { EForms } from "types/enums";
import { resolveFileUrl } from "constants/config";
import { getFriendlyRegionsOptions } from "../rmap/RussiaMap";
import UniVisibilitySwitcher from "../auxiliary/tools/UniVisibilitySwitcher";

const UniProfileIntoPage = () => {
    const { t } = useTranslation();

    const { universityId } = useParams();
    const { id, details: universityDetails = {} } = useStorageListener(
        (state) => _.pick(state?.universities?.[universityId ?? state?.myUniversityId], [`id`, `details`]) ?? {}
    );
    const { data, onSubmit, setValues } = useFormControl({
        name: EForms.uniProfileInfo,
        schema: Schemas.uniProfileInfo
    });
    const navigate = useNavigate();

    const handlers = {
        submit: async (details) => {
            await UniversityApi.updateMyUniversity({ id, details });
            navigate(`/dormitories`);
        }
    };

    useEffect(() => setValues(universityDetails), [universityDetails]);

    console.log("render: UniProfileIntoPage: universityId = ", universityId);
    console.log("render: UniProfileIntoPage: id = ", id);
    console.log("render: UniProfileIntoPage: data = ", data);

    let selCity = data?.city || "РОССИЯ";
    let selCountry = data?.country || "РОССИЯ";
    console.log('render: selCountry = ', selCountry);

    return (
        <AuthStyles.Container extra={`padding-left: 304px; padding-right: 304px;`}>
            <h2>{t("ulaz6h2sk5")}</h2>
            <p>{t("a6uiun0an9n")}</p>
            <Control.Form name={EForms.uniProfileInfo} onSubmit={onSubmit(handlers.submit)} className={"stud_form"}>
                <Control.File name="photo" accept="image/jpeg, image/png" className={"avatar_placeholder"}>
                    <PhotoDropzone src={resolveFileUrl(data?.photo)} />
                </Control.File>
                <Control.Textarea name="name" placeholder={t("38t51rn5uth")} label={t("f7q9gzllpgu")} isRequired />
                <Control.Input name="shortName" placeholder={t("xvvz95zycrr")} label={t("ddwn6473u2m")} />
                <Control.Input name="founderName" placeholder={t("43wi4t732xq")} label={t("3swplcaa09c")} />
                <Control.Input name="site" placeholder={t("s2uijajmhwh")} label={t("15gvdr2sxci")} isRequired />
                <Control.Input name="committee" placeholder={t("krxtyg04yv")} label={t("qcpm6mww8p")} isRequired />
                {/*<Control.Input name="region" placeholder={t("fxrvz0lusx")} label={t("zrqwz7v9mlf")} isRequired />*/}

                <Control.Select
                    name="country"
                    placeholder={'Страна'}
                    label={'Страна'}
                    options={countries.map((i) => ({ value: i.id, label: i.name }))}
                    isRequired
                />

                {/*{selCountry != 'РОССИЯ' ? null :*/}
                    <>
                        <Control.Select
                            name="district"
                            placeholder={t("g062vws7vn")}
                            label={t("nwvs65alhr")}
                            options={districts.map((i) => ({ value: i.id, label: i.name }))}
                        />
                        <Control.Select
                            name="region"
                            placeholder={"Субъект"}
                            label={"Субъект"}
                            options={getFriendlyRegionsOptions().map((i) => ({ value: i.label, label: i.label }))}
                        />
                    </>
                {/*}*/}





                <Control.Input name="city" placeholder={t("v9kry9adh1j")} label={t("fcwc1pbvrxg")} isRequired />

                <Control.File
                    multiple
                    name="video"
                    label={'Видео'}
                    dropzoneProps={{ label: `Загрузить видео (не более 100Мб, формат MP4)`, icon: `dropzone-video` }}
                    accept="video/mp4"
                />

                {id == undefined ? null :
                    <UniVisibilitySwitcher
                        id={id}
                    />
                }

                {/*<Control.Checkbox name="hideMyInfo" placeholder={''} label={'Скрыть всю информацию ВУЗа'} />*/}

                {/* <Control.Input name="reginLink" placeholder="Ссылка" label="Укажите сайт субъекта РФ  (необязательно)" /> */}
                {/* {!data?.campusesNumber && (
                    <>
                        <Control.Error extra={`height: max-content; text-align: center; margin-bottom: 1rem;`}>
                            Без указания кампусав, Вам доступно только бронирование жилья. Добавить кампусы вы сможете в любой момент
                        </Control.Error>
                    </>
                )} */}
                <Button type="submit" background="blue" extra={`width: 100%; padding: `}>
                    {t("wn3vq8r6zbg")}
                </Button>
            </Control.Form>
        </AuthStyles.Container>
    );
};

export default UniProfileIntoPage;
